import type { QueryParams } from "@/lib/api";

/** Every quality cache is company-scoped, so every key carries the active company. Kept apart from queries.ts so another feature can invalidate quality without importing its hooks. */
export const qualityKeys = {
  root: ["quality"] as const,
  all: (c: string | null) => ["quality", c] as const,
  list: (c: string | null, what: string, p: QueryParams) => ["quality", c, what, p] as const,
  detail: (c: string | null, what: string, id: string | null) => ["quality", c, what, "detail", id] as const,
};
